<template lang="html">
  <p class="description-box-content" v-html="descriptionData"></p>
</template>

<script>
export default {
  props: {
    descriptionData: {
      required: true,
    }
  },
  mounted() {
    this.prepareData();
  },
  methods: {
    prepareData() {
      this.$el.removeEventListener('click', this.checkLink);

      this.$el.addEventListener('click', (event) => {
        this.checkLink(event);
      });
    },
    checkLink(event) {
      event.preventDefault();
      var href = event.target.href;
      if(href != undefined) {
        if(href.indexOf('odenserundt.dk') != -1) {
          let split = href.split('odenserundt.dk');
  				this.$router.push(split[1]);
        }
        else {
          window.open(href, '_system', '');
        }
      }
    }
  }
}
</script>

<style lang="css">
  .description-box-content {
    margin: 0;
  }
  .description-box-content a {
    text-decoration: underline;
  }
</style>
